export const aboutData = {
  brandIntro: {
    title: '关于ky体育',
    paragraphs: [
      'ky体育成立于2018年，是一家专注于体育竞技内容与数据服务的综合性平台。我们致力于为全球体育爱好者提供全面、专业、实时的体育赛事资讯与数据分析服务。',
      '自成立以来，ky体育始终坚持"专业、客观、及时"的核心理念，汇聚了来自全球各地的体育数据分析师、资深体育编辑和专业内容创作者，为用户打造一站式的体育内容生态。',
      '目前，ky体育已经覆盖足球、篮球、网球、电竞、赛车、斯诺克等超过20个体育大项，每日更新数千条赛事资讯与数据，月活跃用户超过500万，已成为华语地区领先的体育内容平台之一。',
      '在技术层面，ky体育自主研发了赛事数据实时处理系统与智能内容推荐引擎，能够为用户提供毫秒级的比分更新和个性化的内容推送，确保每一位用户都能第一时间获取自己关心的体育资讯。',
    ],
  },
  honors: [
    {
      year: '2025',
      title: '年度最佳体育资讯平台',
      description: '荣获中国体育产业协会颁发的年度最佳体育资讯平台大奖',
      icon: 'ri-medal-line',
    },
    {
      year: '2025',
      title: '用户最喜爱的体育App TOP3',
      description: '在权威第三方评测中，ky体育位列用户满意度前三名',
      icon: 'ri-heart-line',
    },
    {
      year: '2024',
      title: '最佳数据服务创新奖',
      description: '凭借自主研发的实时数据引擎获得行业创新大奖',
      icon: 'ri-lightbulb-line',
    },
    {
      year: '2024',
      title: '国家级高新技术企业认证',
      description: '正式通过国家级高新技术企业认定，技术实力获权威认可',
      icon: 'ri-shield-check-line',
    },
    {
      year: '2023',
      title: '最佳用户体验设计奖',
      description: '产品界面设计与交互体验获得行业设计专家一致好评',
      icon: 'ri-layout-line',
    },
    {
      year: '2023',
      title: '体育行业影响力品牌',
      description: '入选体育行业年度影响力品牌榜单，品牌价值获市场认可',
      icon: 'ri-star-line',
    },
  ],
  contact: {
    title: '联系我们',
    email: 'contact@ky-sports.com',
    phone: '400-888-6666',
    address: '北京市朝阳区建国路88号SOHO现代城A座2001室',
    workHours: '周一至周五 9:00 - 18:00',
    socialLinks: [
      { name: '微博', icon: 'ri-weibo-line', url: '#' },
      { name: '微信', icon: 'ri-wechat-line', url: '#' },
      { name: '抖音', icon: 'ri-tiktok-line', url: '#' },
    ],
  },
  faq: [
    {
      question: 'ky体育提供哪些体育项目的资讯？',
      answer: 'ky体育目前覆盖足球、篮球、网球、电竞、F1赛车、斯诺克、高尔夫、拳击、综合格斗、乒乓球、羽毛球等超过20个体育大项，涵盖国内外各大主流联赛和杯赛。',
    },
    {
      question: 'ky体育的赛事数据更新频率如何？',
      answer: 'ky体育采用自主研发的实时数据处理引擎，能够在赛事进行中实现毫秒级的数据更新。比分、统计等核心数据延迟通常不超过3秒，确保用户获取最及时的赛事动态。',
    },
    {
      question: '如何在ky体育上找到自己感兴趣的赛事？',
      answer: '您可以通过首页的搜索功能直接搜索，或通过分类导航进入不同的体育类别进行浏览。平台还会根据您的阅读偏好进行个性化的内容推荐。',
    },
    {
      question: 'ky体育的内容是否收费？',
      answer: 'ky体育的基础资讯和数据服务完全免费。部分深度分析报告和高级数据工具为会员专属内容，用户可根据自身需求选择是否订阅。',
    },
    {
      question: '如何成为ky体育的内容创作者？',
      answer: '如果您是体育领域的专业人士或资深爱好者，欢迎通过"联系我们"页面提交您的申请。我们的编辑团队会在收到申请后的3个工作日内与您取得联系。',
    },
  ],
};

export const aboutTimeline = [
  { year: '2018', event: 'ky体育平台正式成立，首发足球赛事数据服务' },
  { year: '2019', event: '新增篮球、网球赛事频道，用户突破100万' },
  { year: '2020', event: '上线电竞赛事频道，成为国内首批电竞数据平台' },
  { year: '2021', event: '完成A轮融资，团队规模扩大至200人' },
  { year: '2022', event: '月活用户突破300万，新增F1、斯诺克等赛事频道' },
  { year: '2023', event: '获得国家级高新技术企业认证，技术实力获权威认可' },
  { year: '2024', event: '人工智能推荐引擎上线，用户体验全面升级' },
  { year: '2025', event: '月活用户突破500万，获评年度最佳体育资讯平台' },
];